var site = site || {};
site.productView = site.productView || {};


$(document).on('prodcat.status', function(e, data) {
  _.each(data.products, function(product, i, products) {
    if (product) {
      _.each(product.skus, function(sku, j, skus) {
      // save the data somewhere
        $(document).data(sku.SKU_ID, sku);
      });
    }
  });

    
  $(".js-inv-status-list").trigger("inventory_status_stored");
  $(".js-add-to-cart").trigger("inventory_status_stored");
  //code will trigger the select box change event on spp page
  if($('div.spp .selectBox').length)
  {
    $('.selectBox').trigger('change');
  }
});


// site.productView.displayInvStatus = function() {
//   if($listNode === undefined) return null;
//   if ($listNode.length < 1) return null;
//   var skuId = $listNode.attr("data-skuid");
//   if (skuId === undefined || skuId.length < 1) return null;
//   var skuData = $(document).data(skuId);
//   if (!skuData || !skuData.INVENTORY_STATUS) return null;
//   $("li", $listNode).hide();
//   $(".js-inv-status-" + skuData.INVENTORY_STATUS, $listNode).show();
// };


site.productView.InvStatusList = function($listNode) {
  var that = {
    $listNode : $listNode
  };
  that.productId = that.$listNode.attr("data-product-id");
  
  that.$listNode.on("inventory_status_stored", function(e) {
    that.updateInvStatus();
    e.stopPropagation();
  });

  that.updateInvStatus = function() {
    var skuId = that.$listNode.attr("data-sku-id");
    var skuData = $(document).data(skuId);
    if (!skuData || !skuData.INVENTORY_STATUS) return null;
    $("li", that.$listNode).hide();
    $(".js-inv-status-" + skuData.INVENTORY_STATUS, that.$listNode).show();
    var $statusToShow = $(".js-inv-status-" + skuData.INVENTORY_STATUS, that.$listNode);
    if ($statusToShow.length > 0) {
      $statusToShow.show();
      that.$listNode.trigger("inventory_status_updated");
    }
  };

  that.updateInvStatus();

  that.$listNode.on('sku:select', function(e, skuData) {
    that.$listNode.attr("data-sku-id", skuData.SKU_ID);
    that.updateInvStatus();
    e.stopPropagation();
  });

  return that;
};

site.productView.collectProductIds = function($context) {
  var prodIds = [];
  $('[data-product-id]', $context).each( function() {
      $this = $(this);
      var prodId = $this.attr('data-product-id');
      var insert = true;
      for (var i=prodIds.length-1; i>-1; i--) {
          if (prodIds[i] == prodId) {
              insert = false;
              break;
          }
      }
      if (insert) {
          prodIds.push(prodId);
      }
      insert = true;
  });
  return prodIds;
};

site.productView.loadL2Data = function(productIds) {
  
  if (!_.isArray(productIds) || productIds.length<1) return null;
  
  generic.jsonrpc.fetch({
    "method":   "prodcat.querykey",
    "params":   [{
        products: productIds,
        query_key: 'catalog-mpp-volatile'
    }],
    "onSuccess" : function (response) {
        var v = response.getValue();
        $(document).trigger('prodcat.status', v);
    }
   });
  
};


(function($) {
  Drupal.behaviors.ELB_invStatusList = {
    attach: function(context, settings) {
      $('.js-inv-status-list').each( function() {
        var invStatusList = site.productView.InvStatusList($(this));
      });
    }
  };
})(jQuery);

